<template>
    <nav class="flex mb-2 md:w-full w-[95%] mx-auto">
      <ol role="list" class="mx-auto flex w-full bg-white">
        <li v-for="(page, index) in paths" :key="index" class="flex">
          <div class="flex items-center" v-if="page.route === '/home'">
            <router-link :to="page.route" class="text-main hover:text-main-hover duration-300">
              <HomeIcon class="md:size-5 size-4 shrink-0" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </router-link>
          </div>
          <div class="flex items-center" v-else-if="index < paths.length - 1">
            <ChevronRightIcon class="h-4 md:h-6 w-4 md:w-6 shrink-0 text-gray-300"/>
            <router-link :to="page.route" class="text-xs md:text-base text-main-hover hover:text-main duration-300">
              <span>{{ page.title }}</span>
            </router-link>
          </div>
          <div class="flex items-center" v-else>
            <ChevronRightIcon class="h-4 md:h-6 w-4 md:w-6 shrink-0 text-gray-300"/>
            <span class="text-xs md:text-base text-gray-500 hover:text-gray-700 font-bold cursor-default select-none">
              <span>{{ page.title }}</span>
            </span>
          </div>
        </li>
      </ol>
    </nav>
</template>

<script>

export default {
  name: "RoutePath",
  data() {
    return {
      paths: [],
    };
  },
  methods: {
    UpdatePaths() {
      const headers = this.$headerStore.headers?.View || [];
      if (!headers.length) {
        this.paths = [];
        return;
      }

      let path = [];
      let currentPage = headers.find((path) => path.id === this.$route.meta.page.id);
      let home = headers.find((path) => path.route === "/home");

      while (currentPage) {
        path.push(currentPage);
        currentPage = headers.find((path) => path.id === currentPage.parent);
      }

      if (!path.includes(home)) {
        path.push(home);
      }
      path = path.reverse();
      this.paths = path;
    },
  },
  mounted() {
    this.UpdatePaths();
  },
  watch: {
    $route() {
      this.UpdatePaths();
    }
  },
};
</script>